import Table from '../../../../global/components/table/Table'
import { Column } from 'react-table'
import { IOrder } from '../../../../../../app/entities/Order'
import NoFilter from '../../../../global/components/table/helpers/filters/NoFilter'
import removeDoubleCommas from '../../../../global/utils/removeDoubleCommas'
import moment from 'moment'
import { DELIVERY_STATUSES_MAP } from '../../../../global/constants/order-status'
import isDeliveryByOrderService from '../../../../global/utils/is-delivery-by-order-service'

interface TrOrdersTableProps {
  orderData: IOrder[]
  isLoading: boolean
}

function TrOrdersTable(props: TrOrdersTableProps) {
  const columns: Column<IOrder | any>[] = [
    {
      Header: 'Order ID',
      accessor: 'workOrderId',
      Filter: NoFilter,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Filter: NoFilter,
      Cell: ({ row: { original } }) => {
        const { status, orderServices } = original as IOrder
        const isDelivery = isDeliveryByOrderService(orderServices || [])
        if (isDelivery) {
          return <div>{DELIVERY_STATUSES_MAP[status || ''] || status}</div>
        } else {
          return <div>{status}</div>
        }
      },
    },
    {
      Header: 'Date',
      Cell: ({ row: { original } }) => {
        const { timeSlot } = original as IOrder
        const date = timeSlot?.fromTime
          ? moment(timeSlot?.fromTime).utc().format('MM/DD/YY')
          : ''
        return <div>{date}</div>
      },
      Filter: NoFilter,
    },
    {
      Header: 'Arrival Window',
      Cell: ({ row: { original } }) => {
        const { timeSlot } = original as IOrder
        const dateStr = timeSlot
          ? `${timeSlot?.fromTimeGenerated || ''} - ${
              timeSlot?.toTimeGenerated || ''
            }`
          : ''
        return <div>{dateStr}</div>
      },
      Filter: NoFilter,
    },
    {
      Header: 'Address',
      Cell: ({ row: { original } }) => {
        const { installationPoint } = original as IOrder
        const formattedAddress = removeDoubleCommas(
          installationPoint?.fullAddress || '',
        )
        return <div>{formattedAddress}</div>
      },
      Filter: NoFilter,
    },
    {
      Header: 'Vehicle',
      Cell: ({ row: { original } }) => {
        const { orderVehicles } = original as IOrder

        const model = orderVehicles?.[0].customerVehicle?.model
        const make = orderVehicles?.[0].customerVehicle?.brand?.name
        const year = orderVehicles?.[0].customerVehicle?.year

        return <div>{`${year} ${make} ${model}`}</div>
      },
      Filter: NoFilter,
    },
    {
      Header: 'Customer Name',
      Cell: ({ row: { original } }) => {
        const { customer } = original as IOrder

        const firstName = customer?.firstName
        const lastInitial = customer?.lastName

        return <div>{` ${firstName} ${lastInitial}`}</div>
      },
      Filter: NoFilter,
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <Table
        columns={columns}
        data={props.orderData ?? []}
        isLoading={props.isLoading}
        isTableTopperPresent={false}
        isDisplayMode={true}
        disableAllRowClicks
      />
    </div>
  )
}

export default TrOrdersTable
